"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScores = createScores;
const childPughClassification_1 = require("../../../forms/ltx/phase-i/medical-history/childPughClassification");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    scores: {
        id: "dashboard.scores",
        defaultMessage: "Score számítások"
    },
    meldScore: {
        id: "dashboard.meld_score",
        defaultMessage: "MELD score"
    },
    meldNaScore: {
        id: "dashboard.meld_na_score",
        defaultMessage: "MELD-Na score"
    },
    childPughScore: {
        id: "dashboard.child_pugh_score",
        defaultMessage: "Child-Pugh score"
    },
    childPughClass: {
        id: "dashboard.calculated_child_pugh_classification",
        defaultMessage: "Számított Child-Pugh osztály"
    }
};
function createScores(intl, { events }) {
    const meldScore = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.meldScore,
        query: queries_1.queries.meldScore
    });
    const meldNaScore = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.meldNaScore,
        query: queries_1.queries.meldNaScore
    });
    const childPughScore = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.childPughScore,
        query: queries_1.queries.childPughScore
    });
    const childPughClass = (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.childPughClass,
        query: queries_1.queries.calculatedChildPughClass,
        messages: childPughClassification_1.childClassificationMessages
    });
    return (0, shared_1.createSection)(intl, {
        label: messages.scores,
        content: (0, shared_1.createSectionContent)([
            meldScore,
            meldNaScore,
            childPughScore,
            childPughClass
        ])
    });
}
